var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnomalySider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 25.5L18.7931 19.2931M1 11.8448C1 6.13154 5.63154 1.5 11.3448 1.5C17.0582 1.5 21.6897 6.13154 21.6897 11.8448C21.6897 17.5582 17.0582 22.1897 11.3448 22.1897C5.63154 22.1897 1 17.5582 1 11.8448Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2348 8.19605L15.2353 10.5M11.1252 12.7645L14.1942 6.64353C14.6244 5.78531 15.8495 5.78554 16.2794 6.64391L19.3456 12.7649C19.734 13.5404 19.1702 14.4535 18.3029 14.4535H12.1677C11.3002 14.4535 10.7364 13.54 11.1252 12.7645ZM15.5266 12.473C15.5266 12.6339 15.3962 12.7644 15.2353 12.7644C15.0744 12.7644 14.9439 12.6339 14.9439 12.473C14.9439 12.3122 15.0744 12.1817 15.2353 12.1817C15.3962 12.1817 15.5266 12.3122 15.5266 12.473Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.706H5L7 6L10 18.5L13.2747 14.706",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnomalySider);
export default __webpack_public_path__ + "static/media/AnomalySider.edc37da576a1b825e118a180b4fae38a.svg";
export { ForwardRef as ReactComponent };